import common from './common';
import sizes from './sizes';
import tabIdentifiers from './tab-identifiers';
import fieldNames, {
  FIELD_NAMES_IN_GENERAL_TAB,
  FIELD_NAMES_IN_SEO_TAB,
  FIELD_NAMES_IN_CUSTOM_CODE_TAB,
} from './field-names';
import { CODE_EDITOR_HEIGHT } from './code-editor-height';

export default {
  common,
  sizes,
  tabIdentifiers,
  CODE_EDITOR_HEIGHT,
  fieldNames,
  FIELD_NAMES_IN_GENERAL_TAB,
  FIELD_NAMES_IN_SEO_TAB,
  FIELD_NAMES_IN_CUSTOM_CODE_TAB,
};
